import {
  FatcaClassification,
  CrsClassification,
} from 'further-types/lp/investor-tax-details';

export const FatcaClassificationLabels = {
  [FatcaClassification.IGAPartnerJurisdictionFinancialInstitution]:
    'IGA Partner Jurisdiction Financial Institution',
  [FatcaClassification.RegisteredDeemedCompliantForeignFinancialInstitution]:
    'Registered Deemed Compliant Foreign Financial Institution',
  [FatcaClassification.ParticipatingForeignFinancialInstitution]:
    'Participating Foreign Financial Institution',
  [FatcaClassification.PartnerJurisdictionFinancialInstitutionWithoutGIIN]:
    'Partner Jurisdiction Financial Institution and has not yet obtained a GIIN',
  [FatcaClassification.SponsoredByAanotherEntityOrTrusteeDocumentedTrust]:
    'The entity has not yet obtained a GIIN but is sponsored by another entity or a Trustee Documented Trust (TDT) which does have a GIIN',
  [FatcaClassification.ParticipatingFinancialInstitutionWithoutGIIN]:
    'Participating Financial Institution that has not obtained a GIIN',
  [FatcaClassification.OwnerDocumentedFinancialInstitution]:
    'Owner Documented Financial Institution',
  [FatcaClassification.NonParticipatingFinancialInstitution]:
    'Non-participating Financial Institution',
  [FatcaClassification.ExemptBeneficialOwner]:
    'The entity is an exempt beneficial owner',
  [FatcaClassification.InvestmentEntityWhollyOwnedByExemptBeneficialOwner]:
    'The entity is an investment entity wholly owned by an exempt beneficial owner',
  [FatcaClassification.ActiveNonFinancialForeignEntity]:
    'The entity is an Active Non-Financial Foreign entity (including an Excepted NFFE)',
  [FatcaClassification.PassiveNonFinancialForeignEntity]:
    'The entity is a Passive Non-Financial Foreign entity',
  [FatcaClassification.OwnerDocumentedNFFE]:
    'Owner Documented Financial Institution',
  [FatcaClassification.DirectReportingNFFE]:
    'The entity is a Direct Reporting NFFE',
  [FatcaClassification.SponsoredDirectReportingNFFE]:
    'The entity is a Sponsored Direct Reporting NFFE',
  [FatcaClassification.SpecifiedUSPersonWithTIN]:
    'The entity is a specified US Person',
  [FatcaClassification.NonSpecifiedUSPerson]:
    'The entity is a US Person that is not a Specified US Person',
  [FatcaClassification.UsResident]:
    'US citizen and/or resident in the US for tax purposes (green card holder or resident under the substantial presence test)',
  [FatcaClassification.FormerUsResident]:
    'Born in the US (or a US territory) but no longer a US citizen as they have voluntarily surrendered the citizenship',
  [FatcaClassification.NonUsResident]:
    'Not a US citizen or resident in the US for tax purposes',
};

export const CrsClassificationLabels = {
  [CrsClassification.InvestmentEntityNonParticipatingJurisdictionManagedByFI]:
    'Investment entity (Non-participating jurisdiction managed by FI) ',
  [CrsClassification.ReportingFIUnderCRS]:
    'Reporting FI under CRS (other than above)',
  [CrsClassification.NonReportingFICRSGovernmentalEntity]:
    'Non-reporting FI under CRS - Governmental entity',
  [CrsClassification.NonReportingFICRSInternationalOrganisation]:
    'Non-reporting FI under CRS - International organisation',
  [CrsClassification.NonReportingFICRSCentralBank]:
    'Non-reporting FI under CRS - Central bank',
  [CrsClassification.NonReportingFICRSPensionFundOfGovernmentalEntity]:
    'Non-reporting FI under CRS - Pension fund of a governmental entity',
  [CrsClassification.NonReportingFICRSQualifiedCreditCardIssuer]:
    'Non-reporting FI under CRS - Qualified credit card issuer',
  [CrsClassification.NonReportingFICRSExemptCollectiveInvestmentVehicle]:
    'Non-reporting FI under CRS - Exempt collective investment vehicle',
  [CrsClassification.NonReportingFICRSTrustTrusteeReportsAllInformation]:
    'Non-reporting FI under CRS - Trust whose trustee reports all information',
  [CrsClassification.NonReportingFICRSBroadOrNarrowRetirementFund]:
    'Non-reporting FI under CRS - Broad or narrow retirement fund',
  [CrsClassification.NonReportingFICRSOther]:
    'Non-reporting FI under CRS - Other',
  [CrsClassification.ActiveNFEGovernmentalEntity]:
    'Active Non-Financial Entity - governmental entity, international organisation, central bank, listed corporation',
  [CrsClassification.ActiveNFEAnyOtherNFE]:
    'Active Non-Financial Entity - any other NFE',
  [CrsClassification.PassiveNFE]: 'Passive Non-Financial Entity',
  [CrsClassification.UsResident]:
    'US citizen and/or resident in the US for tax purposes (green card holder or resident under the substantial presence test)',
  [CrsClassification.FormerUsResident]:
    'Born in the US (or a US territory) but no longer a US citizen as they have voluntarily surrendered the citizenship',
  [CrsClassification.NonUsResident]:
    'Not a US citizen or resident in the US for tax purposes',
};
